module.exports = __webpack_public_path__ + "static/media/rooms7.2f964524.jpg";